import { StorageWrapper } from './StorageWrapper.ts';
export var ShortcutLocation = /*#__PURE__*/ function(ShortcutLocation) {
    ShortcutLocation[ShortcutLocation["InGame"] = 0] = "InGame";
    ShortcutLocation[ShortcutLocation["InLobby"] = 1] = "InLobby";
    ShortcutLocation[ShortcutLocation["General"] = 2] = "General";
    return ShortcutLocation;
}({});
export class KeyBindController {
    static get instance() {
        if (KeyBindController._instance == undefined) KeyBindController._instance = new KeyBindController();
        return KeyBindController._instance;
    }
    static bindKey(keyboardEventCode, onTrigger, isListening, shortcutLocation, withShift = false, minWaitBetweenSameKeyPressInMilliseconds = 500) {
        KeyBindController.instance.bindKey(keyboardEventCode, onTrigger, isListening, shortcutLocation, minWaitBetweenSameKeyPressInMilliseconds, withShift);
    }
    onKeyDown(pressedKeyboardEventCode, pressedShiftKey) {
        if (isTypingInTextInput()) return;
        if (!this.areKeyBindsEnabled) return;
        const currentUnixTime = Date.now();
        for (const keyBind of this.keyBinds){
            const { keyboardEventCode, onTrigger, isListening, shortcutLocation, withShift } = keyBind;
            const shouldTriggerInGameShortcuts = StorageWrapper.getKeyboardShortcuts() === true;
            if (shortcutLocation === 0 && !shouldTriggerInGameShortcuts) continue;
            if (keyboardEventCode != pressedKeyboardEventCode) continue;
            if (withShift && !pressedShiftKey) continue;
            if (pressedShiftKey && !withShift) continue;
            if (isListening() == false) continue;
            const millisecondSinceLastKeyPress = currentUnixTime - this.lastUnixTimeEachKeyWasPressed[keyboardEventCode];
            if (millisecondSinceLastKeyPress < keyBind.minWaitBetweenSameKeyPressInMilliseconds && millisecondSinceLastKeyPress != 0) continue;
            this.lastUnixTimeEachKeyWasPressed[pressedKeyboardEventCode] = currentUnixTime;
            onTrigger();
        }
    }
    bindKey(keyboardEventCode, onTrigger, isListening, shortcutLocation, minWaitBetweenSameKeyPressInMilliseconds, withShift = false) {
        const item = {
            keyboardEventCode: keyboardEventCode,
            onTrigger: onTrigger,
            isListening: isListening,
            shortcutLocation: shortcutLocation,
            minWaitBetweenSameKeyPressInMilliseconds: minWaitBetweenSameKeyPressInMilliseconds,
            withShift: withShift
        };
        this.keyBinds.push(item);
    }
    clearAllKeyBinds() {
        this.keyBinds = [];
    }
    disableKeyBindings() {
        this.areKeyBindsEnabled = false;
    }
    enableKeyBindings() {
        this.areKeyBindsEnabled = true;
    }
    constructor(){
        this.keyBinds = [];
        this.lastUnixTimeEachKeyWasPressed = {};
        this.onKeyDownListener = (keyboardEvent)=>this.onKeyDown(keyboardEvent.code, keyboardEvent.shiftKey);
        document.addEventListener('keydown', this.onKeyDownListener);
        this.areKeyBindsEnabled = true;
    }
}
function isTypingInTextInput() {
    const activeElement = document.activeElement;
    if (activeElement.nodeName != 'INPUT') return false;
    if (activeElement.type != 'text') return false;
    return true;
}
